import { render, staticRenderFns } from "./lianhetiScrollItem.vue?vue&type=template&id=c0ab596e"
import script from "./lianhetiScrollItem.vue?vue&type=script&lang=js"
export * from "./lianhetiScrollItem.vue?vue&type=script&lang=js"
import style0 from "./lianhetiScrollItem.vue?vue&type=style&index=0&id=c0ab596e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports